const partnerProfileDetail = '/Partner-Profile-Detail/';

export { partnerProfileDetail };
